import React, { useEffect, useState } from 'react'
import { BottomContainer, ChallengeDetailsConatainer, ColorBox, LevelConatiner } from '../../UserDashboard/styles'
import { DateContainer, JournalContainer, NoJournalContainer, /*TaskCalendar,*/ TextContainer } from './styles'
import { useParams } from "react-router-dom";
import { GetJournalData, GetJournalEntryByDate, GetWellnessChallengeDetails } from '../../../redux/constants/apiConstants';
import { fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
// import { CalendarPicker, CalendarWrapper } from '../../LogWorkoutCategoryV3/styles';
// import Calendar from 'react-calendar';
import moment from 'moment';
import SubmitJournalModal from './SubmitJournalModal';
import parse from 'react-html-parser';
import { AddJounralIcon, ProgressTickIcon } from '../../../utils/icons';
import {feelingsData} from "../../../../mockData";
import PreQuizModal from '../../UserDashboard/PreQuizModal';
import ChallengeCompleteModal from './ChallengeCompleteModal';
import dayjs from 'dayjs';
import { ProgressBar, ProgressCircleWrapper, ProgressText } from '../styles';





function JournalDetailsPage() {

  const { id } = useParams();
  const[loading, setLoading]= useState(true);
  const[dataLoading, setDataLoading]= useState(true);
  const[journalData, setJournalData]=useState([]);
  const [wellnessChallengeDetails, setWellnessChallengeDetails] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [journalDetails, setJournalDetails] = useState(null);
  // const [isJournalData, setIsJournalData] = useState(null);
  const [showReflectPopup, setShowReflectPopup] = useState(false);
  const [showQuizModal, setShowQuizModal] = useState(false);
  const [showBadgePopup, setShowBadgePopup] = useState(false);
  


  const isLastDaySubmission =
  wellnessChallengeDetails?.challenge_info.challenge_end_at &&
    selectedDate &&
    moment(wellnessChallengeDetails?.challenge_info.challenge_end_at).isSame(moment(selectedDate), "day") &&
    moment(wellnessChallengeDetails?.challenge_info.challenge_end_at).isSame(moment(), "day");


  

  window.console.log("challengeid", id, dataLoading);

  useEffect(()=>{

    if (id) {
      fetchJournalData(id);
      FetchWellnessChallenegesData(id);
    }
   
  },[]);


  useEffect(() => {
    if (!showQuizModal && isLastDaySubmission) {
      window.setTimeout(() => {
        setShowBadgePopup(true);
      }, 300); 
    }
  }, [showQuizModal]);


  const closeSubmitJounalPopup = () => {
    setShowReflectPopup(false);
  
    if (isLastDaySubmission) {
      window.setTimeout(() => {
        setShowQuizModal(true);
      }, 300); // smooth transition
    }
  };



  const FetchWellnessChallenegesData = async (challengeId) => {
    setDataLoading(true);
    try {
      const res = await fetchApi(GetWellnessChallengeDetails + "/" + challengeId, "GET");
      if (res.status === 'success') {
        setWellnessChallengeDetails(res.data);

        const start = moment(res.data.challenge_info.challenge_started_at);
        const end = moment(res.data.challenge_info.challenge_end_at);
        const today = moment();
      
        let defaultDate;
      
        if (today.isBetween(start, end, "day", "[]")) {
          defaultDate = today.toDate();
        } else {
          defaultDate = start.toDate();
        }
      
        setSelectedDate(defaultDate);
        await handleDayClick(defaultDate);
       

      } else {
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
    finally {
      setDataLoading(false);  
    }
  }


  const fetchJournalData = async(challengeId)=>{
    setLoading(true);
    try{
      const res = await fetchApi(GetJournalData + '/' + challengeId);
      if(res.status === 'success'){
        setJournalData(res?.data)
        setLoading(false);
      }else{
        toast.error(res?.data?.message);
        setLoading(false);
      }
    }catch(error){
      window.console.log("error",error);
      setLoading(false);
    }
  }


  const handleDayClick = async(day)=>{
    setSelectedDate(day);
    const formattedDate = moment(day).format("YYYY-MM-DD");

    setLoading(true);
    try{
      const res = await fetchApi(GetJournalEntryByDate + '/' + id + '/' + formattedDate);
      if(res.status === 'success'){
        // const journalArray = res?.data?.journal_entry || [];
        // setIsJournalData(res?.data)
        // const data = res?.data?.[0];


        if (res?.data) {
          setJournalDetails(res?.data);   
          // setShowReflectPopup(false);
        } else {
          setJournalDetails(null);             
          // setShowReflectPopup(true);          
        }
        setLoading(false);
      }else{
        toast.error(res?.data?.message);
        setLoading(false);
      }
    }catch(error){
      window.console.log("error",error);
      setLoading(false);
    }
  }



  const SkeletonLoader = () => {
    window.console.log("")
    return (
      <ChallengeDetailsConatainer style={{gap:"16px"}}>
        <div style={{
          width: "60%",
          height: "200px",
          background: "#eee",
          borderRadius: "8px",
          animation: "pulse 1.5s infinite"
        }} />
  
        <div style={{
          width: "40%",
          height: "400px",
          background: "#eee",
          borderRadius: "8px",
          animation: "pulse 1.5s infinite"
        }} />
      </ChallengeDetailsConatainer>
    );
  };



  const getFeelingEmoji = (feeling) => {
    window.console.log("")
    return feelingsData.find((f) => f.id === feeling)?.emoji || null;
  };



  // const CalendarView = () => {

  //   const startDate = moment(
  //     wellnessChallengeDetails?.challenge_info?.challenge_started_at
  //   );
  
  //   const endDate = moment(
  //     wellnessChallengeDetails?.challenge_info?.challenge_end_at
  //   );
  
  //   const isOutsideRange = (date) => {
  //     window.console.log("")
  //     return (
  //       moment(date).isBefore(startDate, "day") ||
  //       moment(date).isAfter(endDate, "day")
  //     );
  //   };
  
  //   const getJournalStatus = (date) => {
  //     window.console.log("")
  //     return journalData.find((item) =>
  //       moment(item.date).isSame(date, "day")
  //     );
  //   };
  
  //   return (
  //     <CalendarWrapper>
  //       <CalendarPicker>
  //         <TaskCalendar>
  //           <Calendar
  //             value={selectedDate}
  //             onChange={handleDayClick}
  //             // onChange={setSelectedDate}
  //             prevLabel={null}
  //             nextLabel={null}
  //             prev2Label={null}
  //             next2Label={null}
  //             navigationLabel={null}
  //             minDate={startDate.toDate()}
  //             maxDate={endDate.toDate()}
  //             formatShortWeekday={(locale, date) =>
  //               date.toLocaleDateString(locale, { weekday: "short" }).slice(0, 2)
  //             }
  
  //             tileClassName={({ date, view }) => {
  //               if (view !== "month") return null;


  //               // ❌ Outside range → grey
  //               if (isOutsideRange(date)) return "na";
                
  //               const today = moment();
  //               // ⚠️ Future BUT inside challenge → light grey (#F8F8F8)
  //               if (moment(date).isAfter(today, "day")) {
  //                 return "future";
  //               }
  
  
  //               const journal = getJournalStatus(date);
  
  //               let className = "";
  
  //               if (journal) {
  //                 // ✅ GREEN if journal added
  //                 if (journal.has_added_journal_for_day) {
  //                   className = "completed"; // green
  //                 } else {
  //                   className = "missed"; // red
  //                 }
  //               }
  
  //               // ✅ selected
  //               if (selectedDate && moment(date).isSame(selectedDate, "day")) {
  //                 className += " selected";
  //               }
  
  //               return className.trim();
  //             }}

  //             tileDisabled={({ date }) => {
  //               const today = moment();
              
  //               return (
  //                 isOutsideRange(date) ||
  //                 moment(date).isAfter(today, "day")   // ✅ disable future
  //               );
  //             }}
  
  //             // tileDisabled={({ date }) => isOutsideRange(date)}
  //           />
  //         </TaskCalendar>
  //       </CalendarPicker>
  //     </CalendarWrapper>
  //   );
  // };

  const CalendarViewV1 = () => {
    window.console.log("hii")

    // const {daily_progress_tracking}=wellnessChallengeDetails;

    // const startDate = moment(wellnessChallengeDetails?.challenge_info?.challenge_started_at).toDate();
    // const endDate = moment(wellnessChallengeDetails?.challenge_info?.challenge_end_at).toDate();
    
    // const isOutsideRange = (date) => {
    //   window.console.log("")
    //   return (
    //     moment(date).isBefore(startDate, "day") ||
    //     moment(date).isAfter(endDate, "day")
    //   );
    // };


    return (
      <>

        <div>
          <ProgressText>Daily Progress Tracking</ProgressText>
          
          <ProgressCircleWrapper gap={'12px 18px'}>
            {journalData?.map((task, index) => {
              const taskDate = dayjs(task.date);
              const currentDate = dayjs();
           
              {/* const isToday = taskDate.isSame(currentDate, "day"); */}
              const isFutureDay = taskDate.isAfter(currentDate, "day");
              const isCompleted = task.is_completed;
           
              let backgroundColor, borderColor;
           
              if (isFutureDay) {
                backgroundColor = "#F1F8F2"; // future
                borderColor = "#DDEEDF";
              } else if (isCompleted) {
                backgroundColor = "#75B084"; // past completed
                borderColor = "#DDEEDF";
              } else {
                backgroundColor = "#F8F8F8"; // past completed
                borderColor = "#FDD2CB";
              }

              if (dayjs(selectedDate).isSame(taskDate, "day")) {
                backgroundColor = isCompleted ? "#92A4DA" : "#F2F5FB";
                borderColor = isCompleted ? "#E7EEF8" : "#D3DEF2";
              }
           
              return (
                <div className="progressWrapper" key={task.task_id} title={dayjs(task?.date).format("MMMM, DD YYYY")}>
                  <ProgressBar
                    // isShowMore={showMore}
                    backgroundColor={backgroundColor}
                    borderColor={borderColor}
                    circleHeight={'38.92px'}
                    circleWidth={'38.92px'}
                    onClick={()=>!isFutureDay && handleDayClick(task.date)}
                    style={{cursor:!isFutureDay ? 'pointer':'not-allowed'}}
                  >
                    <div className="iconContainer">
                      {isCompleted && ProgressTickIcon("#FFFFFF")}
                    </div>
                  </ProgressBar>
                  <div className="weekLabel">D{index+1}</div>
                </div>
              );
            })}
          </ProgressCircleWrapper>
        </div>
         
        {/* {daily_progress_tracking.length > 7 && (
          <div className="showMoreText" onClick={() => setShowmore((prev) => !prev)}>
            {showMore ? "Show Less" : "Show More"}
            <span
              style={{
                display: "flex",
                transition: "transform 0.3s ease",
                transform: showMore ? "rotate(180deg)" : "rotate(0deg)",
                marginLeft: "8px",
              }}
            >
              {ShowMoreArrow()}
            </span>
          </div>
        )} */}
      </>
    );
  }



  const onHideQuizModal = () => {
    setShowQuizModal(false);
    // FetchWellnessChallenegesData(id); 
  }





  if (loading) {
    return <SkeletonLoader />;
  }


  return (
    <ChallengeDetailsConatainer style={{flexDirection:"column"}}>
      <DateContainer>
        {journalDetails?.formatted_date || moment(selectedDate).format("MMMM DD, YYYY")}
      </DateContainer>

      <div style={{display:"flex",gap:"16px", alignItems: "flex-start",marginTop:"12px" }}>

        {journalDetails?.journal_entry[0] ? <JournalContainer>
          <div className="journalContent">
            {journalDetails?.feeling ? <div className="feelingIcon">{getFeelingEmoji(journalDetails?.feeling)}</div>: null}
            <div>
              <div>
                <TextContainer isFontSize={"18px"} isLineHeight={"24px"} isFontWeight={"700"} > {journalDetails?.journal_entry[0]?.title}</TextContainer>
              </div>
              <div className="aboutext">
                <TextContainer style={{wordBreak:"break-word"}} isFontSize={"18px"} isLineHeight={"24px"} isFontWeight={"400"}>  {parse(journalDetails?.journal_entry[0]?.about_the_day )}</TextContainer>
              </div>
            </div>
          </div>
        </JournalContainer>: 
          <NoJournalContainer>
            <div className='row-one'>
              <div>
                {/* <TextContainer  isFontSize={"18px"} isLineHeight={"24px"} isFontWeight={"700"} >It looks like you haven’t made a journal entry</TextContainer> */}
                {/* <TextContainer isFontSize={"18px"} isLineHeight={"24px"} isMargin={"8px 0 0 0"} isFontWeight={"400"}>Take a moment to reflect on your day, jot down what you learned, or share your feelings.</TextContainer> */}
                <TextContainer isFontSize={"18px"} isLineHeight={"24px"} isFontWeight={"400"}>{journalDetails?.journaling_prompt}</TextContainer>
              </div>
              <div className="plusIcon" onClick={() => setShowReflectPopup(true)}>{AddJounralIcon()}</div>
            </div>

          </NoJournalContainer>
        }

        <LevelConatiner style={{ display: "block",width:"420px" }}>
          {/* <CalendarView/> */}
          {CalendarViewV1()}
          <BottomContainer isWidthSize={"225px"}>
            <div className="secondRow seconRowMargin">
              <div className="rowContennt">
                <ColorBox />
                <div className="textBox">Completed</div>
              </div>
              <div className="rowContennt">
                <ColorBox isColor="#FDD2CB" />
                <div className="textBoxForNC">Not Completed</div>
              </div>
              {/* <div className="rowContennt">
                <ColorBox isColor="#DCDCDC" />
                <div className="textBox">NA</div>
              </div> */}
            </div>
          </BottomContainer>
    
        </LevelConatiner>


      </div>

      {showReflectPopup && (
        <SubmitJournalModal   refreshSelectedDate={handleDayClick}  endDate={wellnessChallengeDetails?.challenge_info.challenge_end_at}   fetchJournalData={fetchJournalData} showModal={showReflectPopup}  onHide={closeSubmitJounalPopup} selectedDate={selectedDate}  challengeId={id} />
      )}

      {showQuizModal && <PreQuizModal showModal={showQuizModal} onHide={onHideQuizModal} challengeId={id}  quizType={'post'}/>}


      {showBadgePopup && (
        <ChallengeCompleteModal
          showModal={showBadgePopup}
          challenge={wellnessChallengeDetails}
          badge={wellnessChallengeDetails?.challenge_achievement?.challenge_badge}
          points={wellnessChallengeDetails?.challenge_achievement?.challenge_points}
          onHide={() => setShowBadgePopup(false)}
        />
      )}

    </ChallengeDetailsConatainer>
  )
}

export default JournalDetailsPage
